<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave única de la moneda"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre de la moneda"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave en el sistema ERP"
    />
    
    <FormField
      id="Simbolo"
      label="Símbolo"
      type="text"
      v-model="formData.Simbolo"
      :maxlength="10"
      helpText="Símbolo de la moneda (ej: $, €, ¥)"
    />
    
    <FormField
      id="Clave2"
      label="Clave 2"
      type="text"
      v-model="formData.Clave2"
      :maxlength="50"
      helpText="Clave secundaria"
    />
    
    <FormField
      id="Clave3"
      label="Clave 3"
      type="text"
      v-model="formData.Clave3"
      :maxlength="50"
      helpText="Clave terciaria"
    />
    
    <FormField
      id="Decimales"
      label="Decimales"
      type="number"
      v-model="formData.Decimales"
      :required="true"
      min="0"
      max="6"
      helpText="Número de decimales (0-6)"
    />
    
    <FormField
      id="Orden"
      label="Orden"
      type="number"
      v-model="formData.Orden"
      :required="true"
      min="0"
      helpText="Orden de visualización"
    />
    
    <FormField
      id="Notas"
      label="Notas"
      type="textarea"
      v-model="formData.Notas"
      :maxlength="500"
      helpText="Notas adicionales"
    />
    
    <FormField
      id="EsActivo"
      label="Activo"
      type="checkbox"
      v-model="formData.EsActivo"
      helpText="Indica si la moneda está activa"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatMonedaForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    moneda: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: null,
        Nombre: '',
        ClaveErp: '',
        EsActivo: true,
        Simbolo: '',
        Clave2: '',
        Clave3: '',
        Decimales: 2,
        Orden: 0,
        Notas: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.moneda }
    };
  },
  watch: {
    moneda: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>